import { action, makeObservable } from 'mobx';

import type { FiltersWidgetStateParams } from './types/state';

export class FiltersUiStore {
  private onStateChange?: (state: FiltersWidgetStateParams) => void;

  constructor(_initialState?: FiltersWidgetStateParams) {
    makeObservable(this);
  }

  @action.bound
  setExternalCallbacks(options: { onStateChange?: (state: FiltersWidgetStateParams) => void }): void {
    this.onStateChange = options.onStateChange;
  }

  getSnapshot(): FiltersWidgetStateParams {
    return {};
  }

  @action.bound
  emitStateChange(): void {
    this.onStateChange?.(this.getSnapshot());
  }

  @action.bound
  dispose(): void {
    this.onStateChange = undefined;
  }
}
